import { create } from "zustand";
import { myTeam } from "../api_layer/api";
import { engagementRepWeekly } from "../api_layer/api";
import { temporaryAssignment } from "../api_layer/api";
import { temporaryEngagement } from "../api_layer/api";
import { repReminder } from "../api_layer/api";
import { roleUser } from "../api_layer/api";

export const useWeeklyScheduleStore = create((set) => ({
  teamData: [],
  repEngData: [],
  tempEngData: [],
  repReminderData: [],
  updateMessage: false,
  teamLoading: false,
  tempEngLoading: false,
  repReminderLoading: false,
  engLoading: false,
  updateLoading: false,
  error: null,
  errorUpdate: null,
  fetchEngData: async (queryParams) => {
    try {
      set({ engLoading: true, error: null });
      const response = await engagementRepWeekly(queryParams);
      set({ repEngData: response.data, engLoading: false });
    } catch (error) {
      set({ error: error.message, engLoading: error });
    }
  },
  fetchTempData: async (queryParams) => {
    try {
      set({ tempEngLoading: true, error: null });
      const response = await temporaryEngagement(queryParams);
      set({ tempEngData: response.data, tempEngLoading: false });
    } catch (error) {
      set({ error: error.message, tempEngLoading: false });
    }
  },
  fetchRepReminder: async (id, start, end) => {
    try {
      set({ repReminderLoading: true, error: null });
      const response = await repReminder(id, start, end);
      set({ repReminderData: response.data, repReminderLoading: false });
    } catch (error) {
      set({ error: error.message, repReminderLoading: false });
    }
  },
  updateEngData: async (
    payload,
    setToaster,
    fetchEngData,
    fetchTempData,
    start,
    end,
    id,
    setAssigneeId,
    refreshChecked,
    setRefreshChecked
  ) => {
    const callFunction = payload?.map((item) => {
      return temporaryAssignment(item);
    });
    try {
      Promise.all(callFunction)
        .then((data) => {
          setToaster("Ticket Assigned", "Assigned Successfully", "success");
          fetchEngData(
            `${id}&start_date=${encodeURIComponent(
              start
            )}&end_date=${encodeURIComponent(end)}`
          );
          fetchTempData(
            `${id}&start_date=${encodeURIComponent(
              start
            )}&end_date=${encodeURIComponent(end)}`
          );
          setAssigneeId(null);
          setRefreshChecked(!refreshChecked);
        })
        .catch((error) => {
          setRefreshChecked(!refreshChecked);
          fetchEngData(
            `${id}&start_date=${encodeURIComponent(
              start
            )}&end_date=${encodeURIComponent(end)}`
          );
          fetchTempData(
            `${id}&start_date=${encodeURIComponent(
              start
            )}&end_date=${encodeURIComponent(end)}`
          );
          setToaster(
            "Ticket Assignment",
            "One or more Engagement Data could not be assigned, Refresh page with latest data",
            "danger"
          );
        });
    } catch (error) {
      setRefreshChecked(!refreshChecked);
      set({ error: error.message, errorUpdate: true });
    }
  },
}));

export const useMyTeam = create((set) => ({
  teamData: [],
  firstID: "",
  teamLoading: false,
  error: null,
  errorUpdate: null,
  fetchMyTeamData: async () => {
    set({ teamLoading: true, error: null });
    try {
      const response = await myTeam();
      set({
        teamData: response.data[0],
        firstID: response.data[0].userGroup[0].user.id,
        teamLoading: false,
      });
      
    } catch (error) {
      set({ error: error.message, teamLoading: false });
    }
  },
}));


export const useAdminManageWeekly = create((set) => ({
  medRepData: [],
  supportData:[],
  medRepExtData:[],
  leadData:[],
  weeklyLoading: false,
  error: null,
  errorUpdate: null,
  fetchMedicalRepData: async (query) => {
    set({ weeklyLoading: true, error: null });
    try {
      const response = await roleUser(query);
      set({medRepData: response.data, weeklyLoading: false,
      });   
    } catch (error) {
      set({ error: error.message, weeklyLoading: false });
    }
  },
  fetchMedicalExtData: async (query) => {
    set({ weeklyLoading: true, error: null });
    try {
      const response = await roleUser(query);
      set({medRepExtData: response.data, weeklyLoading: false,
      });   
    } catch (error) {
      set({ error: error.message, weeklyLoading: false });
    }
  },
  fetchSupportData: async (query) => {
    set({ weeklyLoading: true, error: null });
    try {
      const response = await roleUser(query);
      set({supportData: response.data, weeklyLoading: false,
      });   
    } catch (error) {
      set({ error: error.message, weeklyLoading: false });
    }
  },
  fetchLeadData: async (query) => {
    set({ weeklyLoading: true, error: null });
    try {
      const response = await roleUser(query);
      set({leadData: response.data, weeklyLoading: false,
      });   
    } catch (error) {
      set({ error: error.message, weeklyLoading: false });
    }
  },
}));
